import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import { ICON_CHEVRON_RIGHT_BOLD_BLACK } from '../../../modules/svg/svg'

interface Item {
  title: string
  url: string
}
interface TextCardHorizontalProps {
  item: Item
  onClick?: (item: Item) => void
}

const TextCardHorizontal = ({ item, onClick }: TextCardHorizontalProps) => {
  const isWebview = useIsWebview()
  const router = useAppRouter()
  return (
    <>
      {isWebview ? (
        <>
          <div
            onClick={() => {
              router.push('', {
                appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
                appSendData: {
                  url: item.url,
                },
              })
            }}
            className="mb-[8px] flex cursor-pointer justify-between rounded-lg border px-[16px] py-[24px] shadow"
          >
            <div className="mr-[12px] truncate">{item.title}</div>
            <img src={ICON_CHEVRON_RIGHT_BOLD_BLACK} />
          </div>
        </>
      ) : (
        <a target="_blank" href={item.url} onClick={() => onClick?.(item)} rel="noreferrer">
          <div className="mb-[8px] flex justify-between rounded-lg border px-[16px] py-[24px] shadow">
            <div className="mr-[12px] truncate">{item.title}</div>
            <img src={ICON_CHEVRON_RIGHT_BOLD_BLACK} />
          </div>
        </a>
      )}
    </>
  )
}

export default TextCardHorizontal
